export const _SUCCESS = "_SUCCESS";
export const _FAILURE = "_FAILURE";
export const FETCH_CO_OPERATION_OLD_REQUEST = "FETCH_CO_OPERATION_REQUEST";
export const UPDATE_CO_OPERATIONS_STATUS_OLD_REQUEST = "UPDATE_CO_OPERATIONS_STATUS_REQUEST";
